import * as React from "react";
import { connect } from "react-redux";
import FileBrowserContainer from "../containers/FileBrowserContainer";
import { ScenarioContext, ProgramsContext, withContext } from "@focus/focusUI";
import { QueryParams } from "../components/QueryParams";
export const _FileBrowserConfig = (props) => {
    return (React.createElement(QueryParams, null, ({ params }) => (React.createElement(FileBrowserContainer, { isDialogOpen: props.isDialogOpen, currentPath: props.currentPath, scenario: props.scenario, workspace: props.workspace, program: props.program, panel: params.selectedPanel, element: props.element, field: props.field, onAccept: props.onAccept, onCancel: props.onCancel, isReadOnly: props.isReadOnly }))));
};
const mapStateToProps = (state, { __scenarios, __programs }) => {
    return {
        scenario: __scenarios.selectors.getSelectedScenarioName(state.scenarios),
        workspace: __scenarios.selectors.getSelectedWorkspaceName(state.scenarios),
        program: __programs.selectors.getSelectedProgram(state.programs),
    };
};
const Connected = connect(mapStateToProps)(_FileBrowserConfig);
const contextConfig = {
    __scenarios: ScenarioContext,
    __programs: ProgramsContext,
};
export const FileBrowserConfig = withContext(contextConfig)(Connected);
//# sourceMappingURL=FileBrowserConfig.js.map